module.exports = __webpack_public_path__ + "56637d69c35056bc34a72102a65eb30a.png";